export default "__VITE_ASSET__BWchomXr__"